// @flow

import { observer } from "mobx-react";
import React from "react";

import "./FilePreview.scss";

type Props = {
    file: File
};

@observer
export default class FilePreview extends React.Component<Props> {
    static types: { [string]: Function } = {};

    static pushType(type: string, component: Function) {
        this.types[type] = component;
    }

    render() {
        return <div className="FilePreview">{this.renderByType()}</div>;
    }

    renderByType() {
        let type =
            this.props.file.type.indexOf("video") >= 0
                ? "video"
                : this.props.file.type.indexOf("audio") >= 0
                ? "audio"
                : "image";
        const typeClass = this.constructor.types[type];
        return React.createElement(typeClass, { file: this.props.file });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/FilePreview/FilePreview.js